import Model from "../_model";

export default class ProductModel extends Model {
	constructor(provider) {
		super(provider, "products");
	}

	filter({ filter, pager, sorter, onSuccess, onFail }) {
		return super.filter({
			params: {
				text: filter ? filter.text : undefined,
				productGroupId: filter ? filter.productGroupId : undefined,
			},
			pager,
			sorter,
			onSuccess,
			onFail,
		});
	}

	select({ text, lang, onSuccess, onFail }) {
		return this._get("products/select", {
			params: { text, lang },
			onSuccess,
			onFail,
		});
	}

	listView({ filter, pager, sorter, lang, onSuccess, onFail }) {
		return this._get("products/list-view", {
			params: {
				text: filter.text,
				productGroupId: filter.productGroupId,
				lang,
				page: pager.number,
				size: pager.size,
				sortBy: sorter?.property,
				sortDesc: sorter?.method === "desc",
			},
			onSuccess,
			onFail,
		});
	}

	find(id, { onSuccess, onFail }) {
		return super.find({ id, onSuccess, onFail });
	}

	create(product, { onSuccess, onFail }) {
		const body = {
			name: product.name,
			code: product.code,
			units: product.units.map((u) => ({ code: u.code, name: u.name })),
			productGroupId: product.productGroupId,
			variants: product.variants || [],
			attributes: product.attributes || [],
			description: product.description || "",
			hsCodes: product.hsCodes || [],
			images: product.images || [],
		};
		return super.create(body, { onSuccess, onFail });
	}

	update(product, { onSuccess, onFail }) {
		const body = {
			name: product.name,
			code: product.code,
			productGroupId: product.productGroupId,
			status: product.status,
			units: product.units,
			variants: product.variants || [],
			attributes: product.attributes || [],
			description: product.description || "",
			hsCodes: product.hsCodes || [],
			images: product.images || [],
		};
		return super.update(body, {
			id: product._id || product.id,
			onSuccess,
			onFail,
		});
	}

	delete(id, { onSuccess, onFail }) {
		return super.delete({ id, onSuccess, onFail });
	}

	details({ lang, productId, onSuccess, onFail }) {
		return this._get(`products/${productId}/details`, {
			params: {
				lang,
			},
			onSuccess,
			onFail,
		});
	}

	updateImages(id, images, { onSuccess, onFail }) {
		return this._put(`products/${id}/images`, images, { onSuccess, onFail });
	}

	importBulk(products, { onSuccess, onFail }) {
		return this._post("products/import", products, { onSuccess, onFail });
	}

	addVariant({ productId, variant, onSuccess, onFail }) {
		return this._post(`products/${productId}/variants`, variant, { onSuccess, onFail });
	}

	updateVariant({ productId, variant, onSuccess, onFail }) {
		return this._put(`products/${productId}/variants/${variant._id}`, variant, { onSuccess, onFail });
	}

	deleteVariant({ productId, variantId, onSuccess, onFail }) {
		return this._delete(`products/${productId}/variants/${variantId}`, { onSuccess, onFail });
	}

	addAttribute({ productId, attribute, onSuccess, onFail }) {
		return this._post(`products/${productId}/attributes`, attribute, { onSuccess, onFail });
	}

	updateAttribute({ productId, attribute, onSuccess, onFail }) {
		return this._put(`products/${productId}/attributes/${attribute._id}`, attribute, { onSuccess, onFail });
	}

	deleteAttribute({ productId, attributeId, onSuccess, onFail }) {
		return this._delete(`products/${productId}/attributes/${attributeId}`, { onSuccess, onFail });
	}

	updateDescription(productId, description, { onSuccess, onFail }) {
		return this._put(`products/${productId}`, { partialUpdate: true, description }, { onSuccess, onFail });
	}

	variantMeta({ productId, variantId, lang, onSuccess, onFail }) {
		return this._get(`products/${productId}/meta/${variantId}`, { params: { lang }, onSuccess, onFail });
	}
}
